import { EnvironmentBase } from '../../environment.base';

/**
 * environment settings for deployment on test-slot
 */
export const environment: EnvironmentBase = {
  production: true,
  apiBaseUrl: 'https://pasm-zap-api-test.pasmapps.de',
  version: '1.7.1',
  app: 'portal',
  env: 'shared/environment.test.ts',
  appInsights: { instrumentationKey: '6ad1dace-14e7-45a7-a7f5-15fa76177b13' },
  AadClientId: '2e534fd5-fd60-4321-a5c6-0247d0d8a507',
  AadScope: 'https://pasmb2cdev.onmicrosoft.com/pasm-zap-api-test/API.Access',
  AadAuthorityDomain: 'pasmb2cdev.b2clogin.com',
  AadSignupSigninUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1A_SIGNIN_ONLY',
  AadPasswordResetUrl:
    'https://pasmb2cdev.b2clogin.com/pasmb2cdev.onmicrosoft.com/B2C_1_PasswordReset',
};
